// extracted by mini-css-extract-plugin
export default {"miniDataArea":"MiniDataBox_miniDataArea__tqo2M","countBox":"MiniDataBox_countBox__h8zf3"};